import { connect } from 'react-redux';
import { aGetContent } from '../../action/content.js';

import Title from './title.jsx';

const mapStateToProps = (state) => {
  return {
    titleList: state.titlelist
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetContent: () => {
      dispatch(aGetContent());
    }
  };
};

const CTitle  = connect(
  mapStateToProps,
  mapDispatchToProps
)(Title);

export default CTitle;



// WEBPACK FOOTER //
// ./src/client/components/title/ctitle.js